let styleNode;
let legalSettingsOptions = [];
function createStyles(options = [], isPlain = false) {
    const styles = options.map((option) => {
        let style = '';
        if (option.codeType === 'LEGAL_STATUS') {
            isPlain ? style = `.patsnap-biz-tag_legal.patsnap-biz-tag_legal--plain.patsnap-biz-tag_legal--code_${option.code} {
                color: ${option.color} !important;
                background-color: #fff;
                border-color: ${option.color} !important;
            }` : style = `.patsnap-biz-tag_legal.patsnap-biz-tag_legal--code_${option.code} {
                color: #fff !important;
                background-color:${option.color} !important;
                border-color: ${option.color} !important;
            }`;
        }
        else if (option.codeType === 'LEGAL_EVENT') {
            style = `.patsnap-biz-tag_legal.patsnap-biz-tag_legal--code_${option.code} {
                color: ${option.color} !important;
                background-color: #fff;
                border-color: ${option.color} !important;
            }`;
        }
        else if (option.codeType === 'SIMPLE_LEGAL_STATUS') {
            isPlain ? style = `.patsnap-biz-tag_legal.patsnap-biz-tag_legal--simple.patsnap-biz-tag_legal--plain.patsnap-biz-tag_legal--code_${option.code} {
                color: ${option.color} !important;
                background-color: #fff !important;
                border-color: ${option.color} !important;
            }` : style = `.patsnap-biz-tag_legal.patsnap-biz-tag_legal--simple.patsnap-biz-tag_legal--code_${option.code} {
                color: #fff !important;
                background-color:${option.color} !important;
                border-color: ${option.color} !important;
            }`;
        }
        return style;
    });
    return styles.join('');
}
export function getLegalMessage(_code, simple, locale) {
    for (let i = 0, size = legalSettingsOptions.length; i < size; i++) {
        const { code, codeType, label } = legalSettingsOptions[i];
        if (code !== _code)
            continue;
        if (simple && codeType !== 'SIMPLE_LEGAL_STATUS') {
            continue;
        }
        if (!simple && codeType === 'SIMPLE_LEGAL_STATUS') {
            continue;
        }
        return label[locale];
    }
    return;
}
export function legalSettings(document, options = [], isPlain = false) {
    try {
        document.head.removeChild(styleNode);
    }
    catch (e) { }
    styleNode = document.createElement('style');
    styleNode.type = 'text/css';
    styleNode = styleNode;
    legalSettingsOptions = options;
    document.head.appendChild(styleNode);
    styleNode.innerHTML = createStyles(options, isPlain);
    return styleNode;
}
//# sourceMappingURL=legal-settings.js.map